import { EditorialError, EditorialErrorIdentifier } from '@/components/EditorialErrors/EditorialErrors';

const identifyMissingFromCollections: EditorialErrorIdentifier = ({
	useSpecies,
	useCollections,
}) => {
	const { species } = useSpecies;
	const { findCollectionsOfSpeciesId } = useCollections;

	if (!species) return [];

	const errors = species.data
		.map((species) => {
			const collections = findCollectionsOfSpeciesId(species.id);
			if (collections.length === 0) {
				return {
					title: 'Mist in kwartet',
					description: `Er zijn geen kwartetten waar ${species.attributes.titleShort} in voorkomt.`,
					speciesId: species.id,
				};
			}
			return undefined;
		})
		.filter((error) => error !== undefined) as EditorialError[];

	return errors;
};

export default identifyMissingFromCollections;
